/* eslint-disable no-unreachable */
import React, { useEffect, useState } from 'react';
import { useParams } from "react-router";
// eslint-disable-next-line no-unused-vars
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, updateDoc, setDoc } from "@firebase/firestore";
import { ref, deleteObject } from "firebase/storage";
import {
    AppBar,
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    Menu,
    MenuItem,
    Select,
    Stack,
    TextField,
    Toolbar,

    Tooltip,

    Typography
} from "@mui/material";
import { Favorite, FavoriteBorder } from "@mui/icons-material";
import FeatherIcon from 'feather-icons-react';
import { useNavigate } from "react-router-dom";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { StaticDatePicker, LocalizationProvider } from "@mui/lab";
import { useAuth } from "../../../utils/context/AuthContext";
import { db, storage } from "../../../utils/firebase";
import FloatingAction from "./FloatingAction";
import PageContainer from "../../../components/container/PageContainer";
import { fetchPantryWithId } from '../utils/pantry';
import { titleMatchesIngredient, isAlwaysAvailable, bestMatchIndex } from '../utils/post';
import { duplicateRecipe } from './saveRecipe';
import { amountToDeduct, loadConversionOverrides } from '../utils/units';
import { PLACEHOLDER_IMAGE } from '../utils/constants';
import Grocery from '../utils/grocery';


// import PropTypes from 'prop-types';


function ViewRecipe() {
    const { userid, id } = useParams();
    const nav = useNavigate();
    const user = useAuth();
    const [recipe, setRecipe] = useState({
        postRecipeTitle: "",
        authorUid: "",
        postImageUrl: "",
        postTags: [],
        postDuration: "",
        postDescription: "",
        ingredients: [{
            ingredientQty: "", ingredientText: "", ingredientUnit: "",
        }],
        steps: [{
            stepsImage: "", stepsText: "",
        }],

    });
    const recipeRef = doc(db, 'users', userid, 'posts', id);
    const [isFollowingAuthor, setIsFollowingAuthor] = useState(false);
    const [isLiked, setIsLiked] = useState(false);
    const [author, setAuthor] = useState({
        dpUrl: "", name: ""
    });
    const [anchorEl, setAnchorEl] = useState(null);
    const [duplicating, setDuplicating] = useState(false);
    const [open, setOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [pantryList, setPantryList] = useState([]);
    const [mealType, setMealType] = useState("Breakfast");
    const [disableAddToGrocery, setDisableAddToGrocery] = useState(false);
    // Recipe → grocery review dialog: each missing ingredient as a two-line
    // packs × size card before adding (consistent with the other grocery add
    // points). { include, name, packs, size, unit }
    const [groceryReviewOpen, setGroceryReviewOpen] = useState(false);
    const [groceryRows, setGroceryRows] = useState([]);

    const handleMealTypeChange = (event) => {
        setMealType(event.target.value);
    };

    const handleClose = () => {
        setOpen(false);
    }


    const handleActionBtnClick = () => {
        //
        setOpen(true);
    }
    const handleSave = async () => {
        const plansRef = collection(db, 'users', user.currentUser.uid, 'plans');
        let plansSnapshot = await getDocs(plansRef);
        // check if there is a plan document
        if (plansSnapshot.docs.length === 0) {
            // create a new plan document
            await addDoc(plansRef, {
                planRecipes: {}
            });
            // update the plansSnapshot
            plansSnapshot = await getDocs(plansRef);
        }


        const planRef = doc(db, 'users', user.currentUser.uid, 'plans', plansSnapshot.docs[0].id);
        const plansList = plansSnapshot.docs.map(fetchedPlan => fetchedPlan.data())[0].planRecipes;
        const date = new Date(selectedDate);
        // YYYY-MM-DD 00:00:00.000Z
        const dateString = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} 00:00:00.000Z`;
        const plan = {
            authorUid: recipe.authorUid,
            isDone: false,
            recipeDocId: id,
            recipeDuration: recipe.postDuration,
            recipeImageUrl: recipe.postImageUrl,
            recipeName: recipe.postRecipeTitle,
            recipePlanDate: dateString,
            recipeUuid: `${Date.now().toString()}000`,
            recipeType: mealType,
            postDateCreated: recipe.postDateCreated,
        }
        if (plansList[dateString]) {
            plansList[dateString].push(plan);
        } else {
            plansList[dateString] = [plan];
        }
        await updateDoc(planRef, {
            planRecipes: plansList
        });
        setOpen(false);
        nav('/plan')

    }

    useEffect(() => {
        const recipeSnapshot = getDoc(recipeRef);
        recipeSnapshot.then((response) => {
            if (response.data()) {
                setRecipe(response.data());
                console.log(response.data());
            }
        });
        console.log(recipe);
        console.log(id)


        // load pantryList
        const pantryRef = collection(db, 'users', user.currentUser.uid, 'pantries');
        const pantrySnapshot = getDocs(pantryRef);
        pantrySnapshot.then((response) => {
            const newPantryList = response.docs.map((pantryData) => pantryData.data());
            setPantryList(newPantryList);
        });

        // check if the current user has liked this recipe
        getDoc(doc(db, 'users', userid, 'posts', id, 'likes', user.currentUser.uid))
            .then((snap) => setIsLiked(snap.exists()));

        // load admin-managed unit-conversion overrides
        loadConversionOverrides(db);

    }, [])

    const handleToggleLike = async () => {
        const now = new Date();
        if (isLiked) {
            setIsLiked(false);
            try {
                await deleteDoc(doc(db, 'users', userid, 'posts', id, 'likes', user.currentUser.uid));
                await deleteDoc(doc(db, 'users', user.currentUser.uid, 'likes', id));
            } catch (error) {
                console.log(`🛑 [unlikeRecipe] Fail: ${error}`);
                setIsLiked(true);
            }
        } else {
            setIsLiked(true);
            try {
                await setDoc(doc(db, 'users', userid, 'posts', id, 'likes', user.currentUser.uid), {
                    uid: user.currentUser.uid,
                    name: user.storedUser?.name || '',
                    dpUrl: user.storedUser?.dpUrl || '',
                    dateCreated: now,
                });
                await setDoc(doc(db, 'users', user.currentUser.uid, 'likes', id), {
                    profileUid: userid,
                    postDocId: id,
                    dateCreated: now,
                });
                if (userid !== user.currentUser.uid) {
                    await addDoc(collection(db, 'users', userid, 'notifications'), {
                        uid: user.currentUser.uid,
                        dateCreated: now,
                        type: 'like',
                        postDocId: id,
                    });
                }
            } catch (error) {
                console.log(`🛑 [likeRecipe] Fail: ${error}`);
                setIsLiked(false);
            }
        }
    }

    useEffect(() => {
        if (recipe.authorUid && recipe.authorUid !== user.currentUser.uid) {
            getDoc(doc(db, 'users', user.currentUser.uid, 'following', recipe.authorUid)).then((snap) => {
                setIsFollowingAuthor(snap.exists());
            });
            getDoc(doc(db, 'users', recipe.authorUid)).then((response) => {
                if (response.exists()) setAuthor(response.data());
            });
        } else if (recipe.authorUid) {
            // Own recipe: show my own profile as the author
            setAuthor({
                name: user.storedUser?.name || recipe.authorName || '',
                dpUrl: user.storedUser?.dpUrl || '',
            });
        }
    }, [recipe])

    const deleteImage = (url) => {
        // delete storage images
        const storageRef = ref(storage, url);
        deleteObject(storageRef).then(() => {
            console.log("deleted");
        }).catch((error) => {
            console.log(error);
        });

    }


    const handleDelete = () => {

        console.warn('You clicked the delete icon.');

        recipe.steps.forEach(step => {
            if (step.stepsImage && step.stepsImage.trim() !== "") {
                deleteImage(step.stepsImage);
            }
        });
        // Delete Likes
        console.log("Deleting Likes");
        const likesRef = collection(db, 'users', user.currentUser.uid, 'posts', id, 'likes');
        const likesSnapshot = getDocs(likesRef);
        console.log(likesSnapshot);
        likesSnapshot.then((response) => {
            console.log(response);
            response.docs.forEach((like) => {
                deleteDoc(doc(db, 'users', like.data().uid, 'likes', id)).then(
                    () => {
                        deleteDoc(doc(db, 'users', user.currentUser.uid, 'posts', id, 'likes', like.id));
                    }
                )
            });
            console.log("Likes Deleted");
        });


        // delete firestore doc
        deleteDoc(recipeRef).then(() => {
            console.log("Document successfully deleted!");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });

        // delete algoliaSearchPost instance
        const indexRef = doc(db, 'algoliaPostSearch', id);
        deleteDoc(indexRef).then(() => {
            console.log("Document successfully deleted!");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });




        nav('/');
    };

    // Build the missing-ingredient list (pantry-aware shortfall) and open the
    // review dialog. Each row pre-fills packs=1 × size=needed amount so the user
    // can adjust before adding — same packs × size model as the other grocery
    // add points.
    const handleAddToGrocery = async () => {
        const pantry = await fetchPantryWithId(user, db);
        const rows = [];
        recipe.ingredients.forEach((ingredient) => {
            const qty = parseFloat(ingredient.ingredientQty) || 0;
            // Pantry-aware availability — use the SAME matcher + comparison as the
            // ingredient checkmarks (titleMatchesIngredient + bestMatchIndex) so the
            // dialog agrees with the ✓/? shown on the recipe.
            if (isAlwaysAvailable(ingredient.ingredientText)) {
                // Staples like water/salt — treated as always on hand; skip.
                return;
            }
            const candidates = pantry.filter((item) =>
                titleMatchesIngredient(item.pantryFoodTitle, ingredient.ingredientText));
            const pantryItem = candidates.length
                ? candidates[bestMatchIndex(
                    candidates.map((p) => p.pantryFoodTitle), ingredient.ingredientText,
                    candidates.map((p) => p.pantryQuantity),
                )]
                : null;

            let covered;
            let size;
            if (!pantryItem) {
                // Not in pantry → missing, buy the full recipe amount.
                covered = false;
                size = qty;
            } else {
                // Convert the pantry amount into the ingredient's unit (e.g. recipe
                // tbsp vs pantry tsp), then the shortfall is what's still needed.
                const pantryInIng = amountToDeduct(
                    parseFloat(pantryItem.pantryQuantity) || 0,
                    pantryItem.pantryUnit,
                    ingredient.ingredientUnit,
                    ingredient.ingredientText,
                );
                const shortfall = qty - pantryInIng;
                if (shortfall > 0) {
                    // In pantry but not enough → pre-tick the shortfall.
                    covered = false;
                    size = shortfall;
                } else {
                    // Enough on hand → untick; default to the full recipe amount so
                    // ticking it to restock buys a sensible quantity, not zero.
                    covered = true;
                    size = qty;
                }
            }
            rows.push({
                include: !covered,
                covered,
                name: ingredient.ingredientText.toLowerCase().trim(),
                packs: '1',
                size: `${size}`,
                unit: ingredient.ingredientUnit || '',
            });
        });
        if (rows.length === 0) {
            nav('/grocery');
            return;
        }
        // Missing/short items first, then already-in-pantry (restock) items.
        rows.sort((a, b) => Number(a.covered) - Number(b.covered));
        setGroceryRows(rows);
        setGroceryReviewOpen(true);
    };

    const updateGroceryRow = (i, field, value) => {
        setGroceryRows((prev) => prev.map((r, idx) => (idx === i ? { ...r, [field]: value } : r)));
    };

    const grocerySelectedCount = groceryRows.filter((r) => r.include && r.name.trim()).length;

    const confirmAddToGrocery = () => {
        groceryRows.forEach((r) => {
            if (!r.include || !r.name.trim()) return;
            const packs = parseFloat(r.packs) || 1;
            const size = parseFloat(r.size) || 0;
            const total = (packs || 1) * size;
            // addGroceryItem handles singular/plural dedup and skips plain water.
            Grocery.addGroceryItem(db, user.currentUser.uid, {
                groceryQuantity: `${total || 0}`,
                groceryPackCount: `${packs || 1}`,
                groceryPackSize: `${size}`,
                groceryFoodTitle: r.name.trim(),
                groceryUnit: r.unit,
                groceryImageUrl: PLACEHOLDER_IMAGE,
                groceryIsDone: false,
            });
        });
        setGroceryReviewOpen(false);
        nav('/grocery');
    };

    const handleEdit = () => {
        nav(`/recipes/e/${id}`);
    }

    const handleDuplicate = async () => {
        if (duplicating) return;
        setAnchorEl(null);
        setDuplicating(true);
        try {
            const { postID } = await duplicateRecipe({ db, user, source: recipe });
            // Open the copy in the editor so the user can rename/adjust before it
            // shows up publicly (it's already saved with a distinct "(Copy)" title).
            nav(`/recipes/e/${postID}`);
        } catch (e) {
            console.error('Duplicate recipe failed:', e);
            setDuplicating(false);
        }
    }


    useEffect(() => {
        // check if recipe ingredient is length == 1 and if text is empty
        if (recipe.ingredients.length === 1 && recipe.ingredients[0].ingredientText === "") {
            setDisableAddToGrocery(true);
        } else {
            setDisableAddToGrocery(false);
        }
    }, [recipe])


    const formatTimestamp = (timestamp) => {
        console.log(timestamp);
        const date = new Date(timestamp);
        return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
    }


    return (<PageContainer title={`${recipe.postRecipeTitle} - Spenza`} description={recipe.postDescription}>
        <Grid container justifyContent="flex-end" sx={{ mb: 1, pr: 3 }}>
            <Button
                color="primary"
                startIcon={<FeatherIcon icon="corner-down-left" />}
                onClick={() => nav('/recipes')}
            >
                Back to Recipes
            </Button>
        </Grid>
        <Box>
            <Card>
                <CardContent>
                    {recipe && <Box
                        component='img'
                        src={recipe && recipe.postImageUrl}
                        alt={recipe && recipe.postRecipeTitle}
                        sx={{
                            width: '100%',
                            height: 'auto',
                            maxWidth: 1920,
                            marginY: 3,
                            borderRadius: '25px',
                            maxHeight: '500px',
                            objectFit: 'cover',
                        }}
                    />}
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography
                            variant="h2"
                            sx={{
                                fontWeight: 'bold',
                            }}
                        >
                            { // capitalize first letter of each word
                                recipe && recipe.postRecipeTitle}
                        </Typography>
                        {recipe && recipe.postIsSecret && recipe.authorUid === user.currentUser.uid && (
                            <FeatherIcon icon="lock" width="20" />
                        )}
                    </Stack>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                    >
                        <Typography
                            variant="h5"
                            color="textSecondary"
                            sx={{
                                marginY: 'auto',
                            }}
                        >
                            {recipe && recipe.postTags.map((tag) => (<>
                                <span>{tag} • </span>
                            </>))}
                            {recipe && recipe.postDuration}
                        </Typography>
                        {recipe && recipe.authorUid === user.currentUser.uid && <>
                            <IconButton
                                aria-label="options"
                                variant="contained"
                                color="primary"
                                onClick={(event) => setAnchorEl(event.currentTarget)}
                            >
                                <FeatherIcon icon="more-vertical" />
                            </IconButton>

                            <Menu open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)} anchorEl={anchorEl}>
                                <MenuItem onClick={handleEdit}>Edit</MenuItem>
                                <MenuItem onClick={handleDuplicate} disabled={duplicating}>
                                    {duplicating ? 'Duplicating…' : 'Duplicate'}
                                </MenuItem>
                                <MenuItem onClick={handleDelete}>Delete</MenuItem>
                            </Menu>
                        </>}


                    </Stack>

                    <Stack
                        direction="column"
                        justifyContent="space-between"
                    >
                        <Box display="flex" alignItems="center">
                            <Avatar
                                alt={author && author.name}
                                src={author && author.dpUrl}
                                sx={{
                                    width: 50, height: 50,
                                }}
                            />
                            <Box sx={{ display: 'flex', marginLeft: '10px', flexDirection: 'column' }}>
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {author && author.name}
                                </Typography>
                                {
                                    recipe && recipe.postDateCreated && (<Typography
                                        variant="h6"
                                        color="textSecondary"
                                        sx={{
                                            marginY: 'auto',
                                        }}
                                    >
                                        {formatTimestamp(recipe.postDateCreated.seconds * 1000)}
                                    </Typography>)
                                }
                            </Box>
                        </Box>
                        <Stack direction="row" spacing={1} alignItems="center">
                          {recipe && recipe.authorUid !== user.currentUser.uid && (
                            <Button
                              variant={isFollowingAuthor ? 'outlined' : 'contained'}
                              color="primary"
                              size="small"
                              onClick={async () => {
                                if (isFollowingAuthor) {
                                  await deleteDoc(doc(db, 'users', user.currentUser.uid, 'following', recipe.authorUid));
                                  await deleteDoc(doc(db, 'users', recipe.authorUid, 'followers', user.currentUser.uid));
                                  setIsFollowingAuthor(false);
                                } else {
                                  await setDoc(doc(db, 'users', user.currentUser.uid, 'following', recipe.authorUid), {
                                    uid: recipe.authorUid, name: author?.name || '', dpUrl: author?.dpUrl || '', dateCreated: new Date(),
                                  });
                                  await setDoc(doc(db, 'users', recipe.authorUid, 'followers', user.currentUser.uid), {
                                    uid: user.currentUser.uid, name: user.storedUser?.name || '', dpUrl: user.storedUser?.dpUrl || '', dateCreated: new Date(),
                                  });
                                  setIsFollowingAuthor(true);
                                }
                              }}
                            >
                              {isFollowingAuthor ? 'Following' : 'Follow'}
                            </Button>
                          )}
                          {recipe && recipe.authorUid !== user.currentUser.uid && (
                            <Tooltip title={isLiked ? 'Unlike recipe' : 'Like recipe'} arrow>
                              <IconButton color="primary" onClick={handleToggleLike}>
                                {isLiked ? <Favorite /> : <FavoriteBorder />}
                              </IconButton>
                            </Tooltip>
                          )}
                        </Stack>

                    </Stack>
                    <hr />
                    <Box
                        sx={{
                            marginY: 3,
                        }}
                    >
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: 'bold',
                            }}
                        >
                            Description
                        </Typography>
                        <Typography
                            variant="h5"
                            color="textSecondary"
                        >
                            {recipe && recipe.postDescription}
                        </Typography>
                    </Box>

                    <hr />
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        sx={{
                            marginY: 3,
                        }}
                    >
                        <Typography
                            variant="h5"
                            sx={{
                                marginY: 'auto', fontWeight: 'bold',
                            }}
                        >
                            Ingredients
                        </Typography>
                        <IconButton
                            aria-label="store"
                            color="primary"
                            variant="contained"
                            onClick={handleAddToGrocery}
                            disabled={disableAddToGrocery}
                        >
                            <FeatherIcon icon="shopping-cart" />
                        </IconButton>
                    </Stack>
                    <Stack
                        direction="column"
                        justifyContent="space-between"
                        sx={{
                            marginY: 3,
                        }}
                    >
                        {recipe.ingredients.length > 0 && recipe.ingredients.map((ingredient) => {
                            // if 1 length and empty string, return null
                            if (recipe.ingredients.length === 1 && ingredient.ingredientText === "") {

                                return <Box
                                    display="flex"
                                    sx={{
                                        justifyContent: 'center',
                                    }}

                                >
                                    <Typography
                                        variant="h5"
                                        color="textSecondary"
                                    >
                                        No Ingredients added yet
                                    </Typography>
                                </Box>
                            }

                            // check if ingredient exists in pantry list. 
                            // if quantity is enough return check
                            // if not enough return question mark
                            // if not in pantry return circle
                            let pantryState = 1;
                            const pantryCandidates = isAlwaysAvailable(ingredient.ingredientText)
                                ? []
                                : pantryList.filter((item) => titleMatchesIngredient(item.pantryFoodTitle, ingredient.ingredientText));
                            // Most-specific match, so the ✓/? reflects the item
                            // that gets deducted (e.g. "minced beef" → "beef mince").
                            const pantryItem = pantryCandidates.length
                                ? pantryCandidates[bestMatchIndex(
                                    pantryCandidates.map((p) => p.pantryFoodTitle),
                                    ingredient.ingredientText,
                                    pantryCandidates.map((p) => p.pantryQuantity))]
                                : null;
                            if (isAlwaysAvailable(ingredient.ingredientText)) {
                                pantryState = 1;
                            } else if (pantryItem) {
                                const pantryQty = parseFloat(pantryItem.pantryQuantity);
                                // Convert the needed amount into the pantry item's
                                // unit (e.g. recipe tbsp vs pantry tsp) before comparing.
                                const needed = amountToDeduct(
                                    parseFloat(ingredient.ingredientQty) || 0,
                                    ingredient.ingredientUnit,
                                    pantryItem.pantryUnit,
                                    ingredient.ingredientText,
                                );
                                if (pantryQty === 0) {
                                    pantryState = 3;
                                } else if (pantryQty >= needed) {
                                    pantryState = 1;
                                } else {
                                    pantryState = 2;
                                }
                            } else {
                                pantryState = 3;
                            }





                            return (

                                <Box
                                    display="flex"
                                    sx={{
                                        marginY: 1,
                                    }}
                                    key={Math.random()}
                                >
                                    <Tooltip
                                        title={pantryState === 1 ? "You have enough in your pantry" : pantryState === 2 ? `You only have ${pantryItem.pantryQuantity} ${pantryItem.pantryUnit}` : "You don't have this in your pantry"}
                                        placement="bottom"
                                        arrow
                                    >
                                        <Box

                                        >
                                            {pantryState === 1 ? (
                                                <FeatherIcon icon="check" color="green" />
                                            ) : pantryState === 2 ? (
                                                <FeatherIcon icon="help-circle" color="orange" />
                                            ) : (
                                                <FeatherIcon icon="circle" color="green" />
                                            )}
                                        </Box>



                                    </Tooltip>

                                    <Typography
                                        variant="h5"
                                        sx={{
                                            marginLeft: 2,

                                        }}
                                    >
                                        {ingredient.ingredientQty} {ingredient.ingredientUnit} {ingredient.ingredientText}
                                    </Typography>
                                </Box>

                            )
                        })}

                    </Stack>

                    <hr />

                    <Typography
                        variant="h5"
                        sx={{
                            marginY: 3, fontWeight: 'bold',
                        }}
                    >
                        Steps
                    </Typography>
                    <Stack
                        direction="column"
                        justifyContent="space-evenly"

                    >
                        {recipe.steps && recipe.steps.map((step, index) => {
                            // if length is 1 and no text, return nothing
                            if (recipe.steps.length === 1 && !step.stepsText) {
                                return <Box
                                    display="flex"
                                    sx={{
                                        justifyContent: 'center',
                                    }}

                                >
                                    <Typography
                                        variant="h5"
                                        color="textSecondary"
                                    >
                                        No steps added yet
                                    </Typography>
                                </Box>
                            }

                            return (<Stack
                                direction="column">
                                <Box
                                    display="flex"
                                    sx={{
                                        marginY: 3,
                                    }}
                                >
                                    <Chip
                                        label={index + 1}
                                        color="primary"
                                        variant="contained"
                                    />
                                    <Typography
                                        variant="h5"
                                        sx={{
                                            marginLeft: '25px', marginY: 'auto',
                                        }}
                                    >
                                        {step.stepsText}
                                    </Typography>

                                </Box>
                                {step.stepsImage && <Box
                                    component='img'
                                    src={step.stepsImage}
                                    alt=" "
                                    sx={{
                                        width: '90%',
                                        height: 'auto',
                                        maxWidth: 1920,
                                        marginLeft: '50px',
                                        borderRadius: '25px',
                                        objectFit: 'cover'
                                    }}
                                />}

                            </Stack>)
                        })}


                    </Stack>

                </CardContent>

            </Card>
        </Box>
        <FloatingAction action={handleActionBtnClick} />
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <FeatherIcon icon="x" color="white" />
                    </IconButton>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div" color="white">
                        {recipe && recipe.postRecipeTitle}
                    </Typography>
                    <Button autoFocus
                        variant="contained"
                        onClick={handleSave}>
                        Save
                    </Button>
                </Toolbar>
            </AppBar>


            <DialogContent
                sx={{
                    width: '100%',
                }}
            >
                <Grid container
                    spacing={2}
                    direction="row"
                    justifyContent="center"
                    alignItems="start"
                    sx={{
                        marginY: 3,
                        width: '100%',
                    }}
                >
                    <Grid item xs={12} sm={6}>
                        <Typography
                            variant="h5"
                            sx={{
                                mb: 3, fontWeight: 'bold',
                            }}
                        >
                            Select a date
                        </Typography>
                        <Box
                            component='img'
                            src={recipe && recipe.postImageUrl}
                            alt={recipe && recipe.postRecipeTitle}
                            sx={{
                                width: '100%', maxHeight: 500, borderRadius: '25px', objectFit: 'contain'
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}

                    >
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <StaticDatePicker
                                displayStaticWrapperAs="desktop"
                                label="Date"
                                value={selectedDate}
                                onChange={(newValue) => {
                                    setSelectedDate(newValue);
                                }}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Meal Type</InputLabel>
                            <Select
                                fullWidth
                                labelId="demo-simple-select-label"
                                value={mealType}
                                label="Meal Type"
                                onChange={handleMealTypeChange}
                            >
                                <MenuItem value="Breakfast">Breakfast</MenuItem>
                                <MenuItem value="Lunch">Lunch</MenuItem>
                                <MenuItem value="Dinner">Dinner</MenuItem>
                            </Select>
                        </FormControl>

                    </Grid>
                </Grid>
                {/**
                 * Create date picker
                 */}

            </DialogContent>
        </Dialog>
        <Dialog open={groceryReviewOpen} onClose={() => setGroceryReviewOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle>Add to grocery</DialogTitle>
            <DialogContent sx={{ pt: 2 }}>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                    Review the items you need. Quantity is packs × size per pack.
                </Typography>
                {(() => {
                    const renderRow = (r, i) => {
                        const total = (parseFloat(r.packs) || 0) * (parseFloat(r.size) || 0);
                        return (
                            // eslint-disable-next-line react/no-array-index-key
                            <Box key={i} sx={{ mb: 2 }}>
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <Checkbox
                                        checked={r.include}
                                        onChange={(e) => updateGroceryRow(i, 'include', e.target.checked)}
                                    />
                                    <TextField
                                        size="small"
                                        label="Item"
                                        value={r.name}
                                        onChange={(e) => updateGroceryRow(i, 'name', e.target.value)}
                                        sx={{ flex: 1 }}
                                    />
                                </Stack>
                                <Stack direction="row" spacing={1} alignItems="center" sx={{ pl: 5.5, mt: 1 }}>
                                    <TextField
                                        size="small"
                                        label="Packs"
                                        type="number"
                                        value={r.packs}
                                        onChange={(e) => updateGroceryRow(i, 'packs', e.target.value)}
                                        sx={{ width: 80 }}
                                    />
                                    <Typography sx={{ px: 0.5 }}>×</Typography>
                                    <TextField
                                        size="small"
                                        label="Size per pack"
                                        type="number"
                                        value={r.size}
                                        onChange={(e) => updateGroceryRow(i, 'size', e.target.value)}
                                        sx={{ flex: 1 }}
                                    />
                                    <TextField
                                        size="small"
                                        label="Unit"
                                        value={r.unit}
                                        onChange={(e) => updateGroceryRow(i, 'unit', e.target.value)}
                                        sx={{ width: 90 }}
                                    />
                                </Stack>
                                <Typography variant="caption" color="textSecondary" sx={{ pl: 5.5, display: 'block', mt: 0.5 }}>
                                    {`Total: ${Number.isFinite(total) ? total : 0}${r.unit ? ` ${r.unit}` : ''}`}
                                </Typography>
                            </Box>
                        );
                    };
                    // Keep original indices so updateGroceryRow(i, …) stays correct.
                    const indexed = groceryRows.map((r, i) => ({ r, i }));
                    const missing = indexed.filter(({ r }) => !r.covered);
                    const covered = indexed.filter(({ r }) => r.covered);
                    return (
                        <>
                            {missing.length > 0 && (
                                <Box sx={{ mb: covered.length > 0 ? 2 : 0 }}>
                                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                        Not in your pantry — buy these
                                    </Typography>
                                    {missing.map(({ r, i }) => renderRow(r, i))}
                                </Box>
                            )}
                            {covered.length > 0 && (
                                <Box>
                                    <Divider sx={{ mb: 2 }} />
                                    <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                                        Already in your pantry
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 1.5 }}>
                                        You have enough for this recipe — tick to buy more.
                                    </Typography>
                                    {covered.map(({ r, i }) => renderRow(r, i))}
                                </Box>
                            )}
                        </>
                    );
                })()}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setGroceryReviewOpen(false)} color="inherit">Cancel</Button>
                <Button variant="contained" onClick={confirmAddToGrocery} disabled={grocerySelectedCount === 0}>
                    {`Add ${grocerySelectedCount} to grocery`}
                </Button>
            </DialogActions>
        </Dialog>
    </PageContainer>);
}

ViewRecipe.propTypes = {};

export default ViewRecipe;